var map = {
	"./bakhtar_logo.png": 77,
	"./delhivery_logo.png": 78,
	"./dsc_logo.png": 79,
	"./education.svg": 80,
	"./experience.svg": 81,
	"./feelingProud.svg": 82,
	"./freecopy_logo.png": 83,
	"./github_logo.png": 84,
	"./google_logo.png": 85,
	"./iaf_logo.png": 86,
	"./intel_logo.jpg": 87,
	"./legato_logo.png": 88,
	"./microsoft_logo.png": 89,
	"./mozilla_logo.png": 90,
	"./muffito_logo.png": 91,
	"./projects_image.svg": 92,
	"./servicerocket_logo.png": 93,
	"./usim_logo.png": 94,
	"./yahya_avatar.png": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;